module.exports = __webpack_public_path__ + "static/media/insta1.d9258136.jpg";